import React from 'react';
import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import ArchiveProjectModalAsync from '@atlassian/jira-project-archive-modal/src/async.tsx';
import type { ModalProps as AppProps } from '@atlassian/jira-project-archive-modal/src/ui/archive-modal/types.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import type { ModalProps } from '../../types.tsx';

export type ArchiveProjectModalOptions = {
	projectId: number;
	projectName: string;
	projectType: ProjectType;
	isProjectSimplified: boolean;
};

export type Props = AppProps & ModalProps;

const ArchiveProject = ({ onClose, projectName, projectId, projectType }: Props) => {
	const isAdmin = useIsAdmin();

	const onArchiveSuccess = () => {
		if (isAdmin) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.location.replace('/jira/settings/projects/manage');
		} else {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.location.replace('/jira/projects');
		}
	};

	return (
		<ContextualAnalyticsData sourceName="EditProjectDetails" sourceType={SCREEN}>
			<ArchiveProjectModalAsync
				isProjectSimplified={false}
				onClose={onClose}
				projectName={projectName}
				projectId={projectId}
				projectType={projectType}
				onArchiveSuccess={onArchiveSuccess}
				onArchiveSuccessFlagRestore={undefined}
			/>
		</ContextualAnalyticsData>
	);
};

export default ArchiveProject;
